module.exports = __webpack_public_path__ + "media/images/global/menu/menu2024-11fd80502da2cabd82df7ec19d50d04d.svg";